// src/utils/cardUtils.ts

export const formatCardNumber = (value: string): string => {
    const cleanValue = value.replace(/\D/g, '');
    const match = cleanValue.match(/(\d{1,4})(\d{0,4})(\d{0,4})(\d{0,4})/);

    if (!match) return value;

    return [match[1], match[2], match[3], match[4]]
        .filter(Boolean)
        .join(' ')
        .trim();
};

export const getCardType = (cardNumber: string): string => {
    const cleanNumber = cardNumber.replace(/\D/g, '');

    if (/^4/.test(cleanNumber)) return 'visa';
    if (/^5[1-5]/.test(cleanNumber) || /^2[2-7]/.test(cleanNumber)) return 'mastercard';
    if (/^3[47]/.test(cleanNumber)) return 'amex';
    if (/^6(?:011|5)/.test(cleanNumber)) return 'discover';
    if (/^35/.test(cleanNumber)) return 'jcb';
    if (/^30[0-5]/.test(cleanNumber) || /^36/.test(cleanNumber) || /^38/.test(cleanNumber)) return 'diners';

    return 'unknown';
};

export const getCardIcon = (cardType: string): string => {
    const icons: Record<string, string> = {
        visa: '💳',
        mastercard: '💳',
        amex: '💳',
        discover: '💳',
        jcb: '💳',
        diners: '💳',
        unknown: '💳',
    };

    return icons[cardType] || icons.unknown;
};

export const maskCardNumber = (cardNumber: string): string => {
    const cleanNumber = cardNumber.replace(/\D/g, '');
    if (cleanNumber.length < 4) return cardNumber;

    const lastFour = cleanNumber.slice(-4);
    const masked = '*'.repeat(cleanNumber.length - 4);

    return formatCardNumber(masked + lastFour);
};

export const getCVVLength = (cardType: string): number => {
    return cardType === 'amex' ? 4 : 3;
};

export const formatExpirationDate = (month: string, year: string): string => {
    if (!month || !year) return '';
    return `${month.padStart(2, '0')}/${year.slice(-2)}`;
};